var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: "筛选详情",
        visible: _vm.dialogVisible,
        width: "1300px",
        "show-close": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "total" }, [
        _c("div", [
          _vm._v("总金额："),
          _c("span", { staticClass: "red" }, [
            _vm._v(_vm._s(_vm.totalAmount) + " USD"),
          ]),
        ]),
        _c("div", [
          _vm._v("总条数："),
          _c("span", { staticClass: "red" }, [_vm._v(_vm._s(_vm.total))]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("BaseTable", {
            key: _vm.dialogVisible,
            ref: "myTabel",
            attrs: {
              height: "540",
              tableData: _vm.tableData,
              loading: _vm.loading,
              isPager: false,
              border: true,
            },
            on: { sortChange: _vm.sortChange },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }